export enum ContactType {
    Billing = 'Billing',
    Primary = 'Primary',
    Technical = 'Technical',
    Clinical = 'Clinical',
}
